export type IcEmptyStateAlignment = "left" | "center" | "right";
